import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './QuickStats.module.css';

const STATS = [
  { value: '12', label: 'Branches in KSA' },
  { value: '10', label: 'Countries' },
  { value: 'Air · Sea', label: 'Door to door' },
];

/** Three at-a-glance numbers under the hero — phones only (the desktop hero
    already says this across its wider layout). */
const QuickStats: React.FC = () => (
  <section className={styles.stats} aria-label="Sahari Cargo at a glance">
    <Container fluid="xl" className={styles.inner}>
      <ul className={styles.list}>
        {STATS.map((s) => (
          <li key={s.label} className={styles.item}>
            <strong className={styles.value}>{s.value}</strong>
            <span className={styles.label}>{s.label}</span>
          </li>
        ))}
      </ul>
    </Container>
  </section>
);

export default QuickStats;
